import { CancelAsync } from './../../app/models/cancelAsync';
import {
  Component,
  OnInit,
  HostListener,
  ViewChild,
  Renderer2,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder } from '@angular/forms';

import {
  NavController,
  Platform,
  ModalController,
  IonContent,
} from '@ionic/angular';

import { ModalMarketingComponent, ModalIframeComponent } from '@app/modals';

import {
  PageLoaderService,
  AppInitService,
  StatsService,
  StudentService,
  SessionsService,
  SeriesService,
  SyncCDRService,
  NavigationService,
  AppRatingService,
  NetworkStatusService,
  SentryService,
  UserErrorHandlerService,
} from '@app/services';

import { Student, StudentPurshasesDetails } from '@app/models';
import { Serie } from '../../app/models/serie';
import { Session } from '../../app/models/session';

import { EasyDebugLogger } from '../../app/easy-debug-logger/easy-debug-logger';

import { ToasterService, UtilsService } from '@commons/services';

import { EasyDebugDecorator } from '../../app/decorators/easy-debug.decorator';

@EasyDebugDecorator
@Component({
  selector: 'buffer-page',
  templateUrl: 'buffer.page.html',
  styleUrls: ['buffer.page.scss'],
})
export class BufferPage extends CancelAsync implements OnInit {
  @ViewChild('modalSerieError') modalSerieError: any;
  @ViewChild('roundedBtnLaunch') roundedBtnLaunch: any;
  @ViewChild('fxCircle') fxCircle: any;
  @ViewChild('three') three: any;
  @ViewChild('two') two: any;
  @ViewChild('one') one: any;
  @ViewChild('go') go: any;

  student: Student = null;
  userLifeCycle: any;

  easyDebugLogger = EasyDebugLogger.getInstance();

  isDesktop = window.innerWidth > 767 ? true : false;

  pageTitle = 'Séries';
  activeLink = 'code';
  serieType = 'entrainements';

  longLoading = false;
  pageStart = Date.now();
  checkPageLoadingTimeInterval: any;

  blocHeaderTitle = 'Chargement...';
  blocHeaderBackTitle = '';
  blocHeaderBackUrl = '';

  serieId: string;
  questionIndex: any;
  sessionId: string;
  serie: Serie;
  sessions: Array<Session>;
  getSessionsFailed = false;

  nbAnswersRef = 40;

  iconPath = './uikit-assets/icons/orion-svg-sprite.svg#';

  objectKeys = Object.keys;

  serieStats = [];
  lastScore = 0;
  lastSessionId: any = 0;

  bufferLocked = false;
  bufferLoaded = false;

  lastResultSession: any;

  seriesList: Array<Serie> = [];
  seriesListFailed = false;
  utilsSeries: any[] = [];
  getSerieFailed = false;

  isCordova = false;

  sessionError = null;
  serieErrorAvailable = false;
  getErrorSessionFailed = false;

  authDownload = false;

  // PAYMENTS GIFTS OFFERS
  studentPurshases: StudentPurshasesDetails;
  payments = [];
  gifts = [];
  coupons = [];
  paymentsGiftsCoupons: any = [];
  offers: any = [];
  fetchOffersFailed = false;
  isPackPermis = false;
  isPackCode = false;
  isPackCodePremium = false;
  isHourOnly = false;
  hasHours = false;
  paymentsDone = false;

  stepChangeSub: any;
  pageLoaderSteps = [
    'init0',
    'init1',
    'init2',
    'init3',
    'init4',
    'init5',
    'initPage',
  ];
  hasMadeInit = false;

  displayModalResetErrors = false;
  displayModalSerieError = false;

  waitingForApi = false;
  customBufferDiscoveryPostRegistration = false;

  fxCountShown = false;
  fxCountFinished = false;
  skipUrl = null;
  urlSkipped = false;

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.isDesktop = window.innerWidth > 767 ? true : false;
  }

  constructor(
    public pageLoaderService: PageLoaderService,
    public navController: NavController,
    public navigationService: NavigationService,
    public appInitService: AppInitService,
    private activatedRoute: ActivatedRoute,
    private statsService: StatsService,
    private router: Router,
    private toasterService: ToasterService,
    private utils: UtilsService,
    private seriesService: SeriesService,
    private syncCDRService: SyncCDRService,
    private sessionsService: SessionsService,
    private studentService: StudentService,
    public formBuilder: UntypedFormBuilder,
    private modalController: ModalController,
    public renderer: Renderer2,
    public platform: Platform,
    public networkStatusService: NetworkStatusService,
    private appRatingService: AppRatingService,
    private sentryService: SentryService,
    private userErrorHandlerService: UserErrorHandlerService
  ) {
    super({ cancel: false, subscription: null });

    // reset
    this.serie = null;
    this.bufferLocked = false;
    this.bufferLoaded = false;

    this.checkPageLoadingTimeInterval = setInterval(() => {
      const now = Date.now();
      // 3 sec
      if (now - this.pageStart >= 3000) {
        this.longLoading = true;
        clearInterval(this.checkPageLoadingTimeInterval);
      }
    }, 200);

    if (!this.appInitService.done) {
      this.navigationService.timestamp = Date.now();
      this.navigationService.lastLink = this.router.url.substr(1);
      this.hasMadeInit = true;
    } else {
      this.hasMadeInit = false;
    }

    this.isCordova = this.platform.is('cordova');

    // si pas de session ou serieId etc. ca veut dire qu'on est sur le cas du buffer locked else garder les anti-couillons

    this.userLifeCycle = this.studentService.getUserLifeCycle(this.student); // if student not ready return guest
    this.serieType = this.activatedRoute.snapshot.paramMap.get('type');
    this.serieId = this.activatedRoute.snapshot.paramMap.get('serieId');
    this.questionIndex =
      this.activatedRoute.snapshot.paramMap.get('questionIndex');
    this.questionIndex = Number(this.questionIndex);
    this.sessionId = this.activatedRoute.snapshot.paramMap.get('sessionId');
    if (!this.serieId) {
      this.bufferLocked = true;
    }
    this.blocHeaderBackTitle = !this.bufferLocked ? 'Retour' : 'Code';

    const getBackNavigation = this.navigationService.checkUserNavigation();
    if (!!getBackNavigation && !!getBackNavigation.url) {
      let verifiedUrl = getBackNavigation.url;
      if (getBackNavigation.url.includes('register')) {
        verifiedUrl = this.bufferLocked ? 'code' : 'series/' + this.serieType;
      }
      this.blocHeaderBackUrl = verifiedUrl;
      this.activeLink = verifiedUrl;
    } else {
      this.blocHeaderBackUrl = this.bufferLocked
        ? 'code'
        : 'series/' + this.serieType;
    }

    if (this.appInitService.done) {
      this.pageLoaderSteps = ['initApp', 'initPage'];
      this.pageLoaderService.setSteps(
        this.pageLoaderSteps.indexOf('initApp') + 1,
        this.pageLoaderSteps.length
      );
    }
    this.stepChangeSub = this.appInitService.onStepChange().subscribe(state => {
      if (state?.init && state?.stepDone) {
        this.pageLoaderService.setSteps(
          state.init + 1,
          this.pageLoaderSteps.length
        );
      }
      if (state?.initDone) {
        this.initPage();
      }
    });
  }

  ionViewWillLeave() {
    this.cancel = true;
    if (!!this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  async initPage() {
    this.student = this.studentService.student;
    this.userLifeCycle = this.studentService.getUserLifeCycle(this.student);

    this.getPayments();
    if (this.router.url.substr(1) === 'serie-discovery') {
      const resSeriesList =
        await this.seriesService.seriesContext.getSeriesList(this.student);
      if (
        !!resSeriesList &&
        !!resSeriesList.errorCode &&
        resSeriesList.errorCode === 'E301'
      ) {
        this.seriesListFailed = true;
      } else {
        this.seriesList = resSeriesList;
      }
      if (!!this.seriesList && this.seriesList.length > 0) {
        for (const serie of this.seriesList) {
          if (this.cancel) {
            this.cancel = false;
            return;
          }
          if (serie.type === 'Discovery' && Number(serie.position) === 0) {
            this.customBufferDiscoveryPostRegistration = true;
            this.serieType = 'entrainements';
            this.serieId = serie.id;
            this.bufferLocked = false;
          }
        }
      } else {
        this.seriesListFailed = true;
      }
    }
    if (this.serieType === 'erreurs') {
      const resSeriesList =
        await this.seriesService.seriesContext.getSeriesList(this.student);
      if (
        !!resSeriesList &&
        !!resSeriesList.errorCode &&
        resSeriesList.errorCode === 'E301'
      ) {
        this.seriesList = [];
        this.seriesListFailed = true;
      } else {
        this.seriesList = resSeriesList;
      }
      if (!!this.seriesList && this.seriesList.length > 0) {
        for (const serie of this.seriesList) {
          if (this.cancel) {
            this.cancel = false;
            return;
          }
          if (serie.type === 'Error') {
            if (
              !!this.seriesService.currentSerie &&
              this.seriesService.currentSerie.id === serie.id
            ) {
              this.serie = this.seriesService.currentSerie;
            } else {
              const resGetSerie =
                await this.seriesService.seriesContext.getSerie(
                  serie.id,
                  this.student,
                  true
                );
              if (
                !!resGetSerie &&
                !!resGetSerie.errorCode &&
                resGetSerie.errorCode === 'E301'
              ) {
                this.getSerieFailed = true;
                // this.userErrorHandlerService.addError({criticity: 20, service: 'getSerie', platform: 'both', data: resGetSerie.errorOriginal, errorCode: 'ssfsr'});
              } else {
                this.seriesService.currentSerie = resGetSerie;
                // this.seriesService.currentSerie = await this.syncCDRService.updateSerieData(this.student, resGetSerie, this.sessions);
                this.serie = this.seriesService.currentSerie;
              }
            }
            // console.log('init buffer => ', this.serie);
            const resGetErrorSession =
              await this.sessionsService.sessionsContext.getErrorSession(
                this.student
              );
            if (
              !!resGetErrorSession &&
              !!resGetErrorSession.errorCode &&
              resGetErrorSession.errorCode === 'E301'
            ) {
              this.sessionError = null;
              this.getErrorSessionFailed = true;
            } else {
              this.sessionError = resGetErrorSession;
            }
            if (!!this.serie && !!this.sessionError) {
              this.bufferLocked = false;
              this.serieErrorAvailable = true;
            } else {
              this.serieErrorAvailable = false;
              this.bufferLoaded = true;
            }
          }
        }
      } else {
        this.seriesListFailed = true;
        this.blocHeaderTitle = 'Retour';
        this.bufferLoaded = true;
      }
    } else {
      if (
        !!this.seriesService.currentSerie &&
        !!this.seriesService.currentSerie.id &&
        this.seriesService.currentSerie.id === this.serieId
      ) {
        this.serie = this.seriesService.currentSerie;
      } else {
        if (!!this.serieId) {
          let serie = null;
          const resGetSerie = await this.seriesService.seriesContext.getSerie(
            this.serieId,
            this.student,
            true
          );
          if (
            !!resGetSerie &&
            !!resGetSerie.errorCode &&
            resGetSerie.errorCode === 'E301'
          ) {
            this.getSerieFailed = true;
            // this.userErrorHandlerService.addError({criticity: 20, service: 'getSerie', platform: 'both', data: resGetSerie.errorOriginal, errorCode: 'ssfsr'});
          } else {
            serie = resGetSerie;
          }
          this.seriesService.currentSerie = serie;
          this.serie = this.seriesService.currentSerie;
        }
      }
      const resgetSessions =
        await this.sessionsService.sessionsContext.getSessions(this.student);
      if (
        !!resgetSessions &&
        !!resgetSessions.errorCode &&
        resgetSessions.errorCode === 'E301'
      ) {
        this.sessions = [];
        this.getSessionsFailed = true;
        this.userErrorHandlerService.addError({
          criticity: 30,
          service: 'fetchSessions',
          platform: 'both',
          data: resgetSessions.errorOriginal,
          errorCode: 'ssfss',
        });
      } else {
        this.sessions = resgetSessions;
      }
    }
    if (!!this.serie) {
      if (!!this.sessions && this.sessions.length > 0) {
        const modes = {
          entrainements: 0,
          examens: 1,
          thematiques: 0,
          erreurs: 0,
        };
        let session: Session[];
        session = this.sessions.filter(
          elt => elt.id === this.serie.lastSessions[modes[this.serieType]]
        );
        if (session.length > 0) {
          this.questionIndex =
            !!session[0].answersCount &&
            session[0].answersCount < this.serie.nbQuestions &&
            session[0].answersCount > 0
              ? session[0].answersCount
              : 0;
        }
      }
    } else {
      this.getSerieFailed = true;
    }
    if (
      !!this.serie &&
      this.serieType === 'thematiques' &&
      this.serie.type === 'Thematic' &&
      !this.serie.theme
    ) {
      this.serie.theme = ['Autres'];
    }
    const titles = {
      entrainements: 'Séries simples',
      examens: 'Examens blancs',
      thematiques: 'Séries thématiques',
      erreurs: 'Mes erreurs',
    };
    if (!!this.serie) {
      // console.log('serie', this.serie);
      if (this.serieType === 'erreurs') {
        this.blocHeaderTitle = 'Retour';
      } else {
        this.nbAnswersRef =
          !!this.serie && !!this.serie.questions ? this.serie.nbQuestions : 0;
        this.blocHeaderTitle = 'Retour';
        // if (this.serieType !== 'thematiques') {
        //   this.blocHeaderTitle = titles[this.serieType];
        // } else {
        //   this.blocHeaderTitle = (!!this.serie.theme) ? titles[this.serieType] + ' - ' + this.serie.theme : titles[this.serieType];
        // }
        await this.calculBufferPageStats();
        this.appRatingService.checkRating(this.student, this.sessions);
      }
      this.bufferLoaded = true;
    } else {
      // console.log('no Serie');
      if (!this.bufferLocked) {
        if (this.getSerieFailed) {
          this.bufferLocked = true;
          this.blocHeaderTitle = 'Retour';
          this.bufferLoaded = true;
        }
      } else {
        // this.blocHeaderTitle = titles[this.serieType];
        this.blocHeaderTitle = 'Retour';
        this.bufferLoaded = true;
      }
    }
    this.pageLoaderService.setSteps(
      this.pageLoaderSteps.indexOf('initPage') + 1,
      this.pageLoaderSteps.length
    );
    setTimeout(() => {
      this.pageLoaderService.stepsDone();
    }, 300);
    // PAGE LOAD EVENT
    if (
      !!this.navigationService.timestamp &&
      !!this.navigationService.lastLink
    ) {
      let lastLink = this.navigationService.lastLink;
      if (!!this.serie && this.serie.type === 'Discovery') {
        lastLink = this.navigationService.lastLink.replace(
          'entrainements',
          'discovery'
        );
      }
      const statObj = {
        page: lastLink,
        loadTime: Date.now() - this.navigationService.timestamp,
        withInit: this.hasMadeInit,
      };
      if (this.statsService.isDebug) {
        console.log(statObj);
      }
      this.statsService.send({ name: 'page:view', payload: statObj });
    }
    // console.log(this.serie);
  }

  async ngOnInit() {}

  getPayments() {
    this.studentPurshases = this.studentService.getStudentPurshases();

    const resGetOffers = this.studentPurshases.offers;
    if (
      !!resGetOffers &&
      !!resGetOffers.errorCode &&
      resGetOffers.errorCode === 'E301'
    ) {
      this.fetchOffersFailed = true;
    } else {
      this.offers = resGetOffers;
    }
    this.gifts = this.studentPurshases.gifts;
    this.studentPurshases.linkOfferTopayment();
    this.studentPurshases.removeCouponsIfPresentInPayments();
    this.payments = this.studentPurshases.payments;
    this.coupons = this.studentPurshases.coupons;

    this.hasHours = this.studentPurshases.hasHours();
    this.isHourOnly = this.studentPurshases.isHourOnly();
    this.isPackCode = this.studentPurshases.isPackCode();
    this.isPackCodePremium = this.studentPurshases.isPackCodePremium();
    this.isPackPermis = this.studentPurshases.isPackPermis();

    const tmp = this.gifts.concat(this.coupons);
    this.paymentsGiftsCoupons = tmp.concat(this.payments);

    this.paymentsDone = true;
  }

  async calculBufferPageStats() {
    // console.log('calculBufferPageStats sessions', JSON.parse(JSON.stringify(this.sessions)));
    // console.log('calculBufferPageStats session of serie', JSON.parse(JSON.stringify(this.sessions.filter(session => session.serieId === this.serie.id))));
    let filteredSesions = [];
    const modes = {
      entrainements: 'Cdr::TrainingSession',
      examens: 'Cdr::ExamSession',
      thematiques: 'Cdr::TrainingSession',
      erreurs: 'Cdr::TrainingSession',
    };
    if (this.serieType !== 'thematiques') {
      filteredSesions = this.sessions
        .filter(session => session.serieId === this.serie.id)
        .filter(session => session.mode === modes[this.serieType])
        .filter(session => session.state !== 'pending');
      // console.log('calculBufferPageStats filteredSesions', JSON.parse(JSON.stringify(filteredSesions)));
    } else {
      let series: Serie[] = [];
      const resSeriesList =
        await this.seriesService.seriesContext.getSeriesList(this.student);
      if (
        !!resSeriesList &&
        !!resSeriesList.errorCode &&
        resSeriesList.errorCode === 'E301'
      ) {
        series = [];
        this.seriesListFailed = true;
      } else {
        series = resSeriesList;
      }
      const thematicsSeries = series.filter(
        elt => elt.type === 'Thematic' && elt.theme === this.serie.theme
      );
      const sessionsThematics: any = this.sessions.filter(elt =>
        thematicsSeries.map(elm => elm.id).includes(elt.serieId)
      );
      const filteredThematiquesSesions = sessionsThematics.filter(
        session => session.state !== 'pending'
      );
      for (const session of filteredThematiquesSesions) {
        let currentSerie;
        if (
          !!this.seriesService.currentSerie &&
          this.seriesService.currentSerie.id === this.serieId
        ) {
          currentSerie = this.seriesService.currentSerie;
        } else {
          const resGetSerie = await this.seriesService.seriesContext.getSerie(
            this.serieId,
            this.student,
            true
          );
          if (
            !!resGetSerie &&
            !!resGetSerie.errorCode &&
            resGetSerie.errorCode === 'E301'
          ) {
            this.getSerieFailed = true;
            // this.userErrorHandlerService.addError({criticity: 20, service: 'getSerie', platform: 'both', data: resGetSerie.errorOriginal, errorCode: 'ssfsr'});
          } else {
            this.seriesService.currentSerie = resGetSerie;
            currentSerie = this.seriesService.currentSerie;
          }
        }
        if (this.serie.theme === currentSerie.theme) {
          filteredSesions.push(session);
        }
      }
    }
    filteredSesions.sort((a, b) => {
      // DATE TO CHANGE
      return +new Date(b.lastAnsweredAt) - +new Date(a.lastAnsweredAt);
    });
    // console.log('calculBufferPageStats last session', JSON.parse(JSON.stringify(filteredSesions[0])));
    let bestScore = 0;
    let serieFinished = 0;
    if (!!filteredSesions && filteredSesions.length > 0) {
      this.lastResultSession = filteredSesions[0];
      this.lastSessionId =
        typeof filteredSesions[0].id !== 'undefined' &&
        filteredSesions[0].id !== ''
          ? filteredSesions[0].id
          : 0;
      this.lastScore = filteredSesions[0].stats.goodAnswers;
      if (filteredSesions[0].answersCount !== this.nbAnswersRef) {
        this.lastScore = Math.round(
          (filteredSesions[0].stats.goodAnswers * this.nbAnswersRef) /
            filteredSesions[0].answersCount
        );
      }
      for (const session of filteredSesions) {
        let currentScore = session.stats.goodAnswers;
        if (session.answersCount !== this.nbAnswersRef) {
          currentScore = Math.round(
            (session.stats.goodAnswers * this.nbAnswersRef) /
              session.answersCount
          );
        }
        bestScore = currentScore > bestScore ? currentScore : bestScore;
        serieFinished++;
      }
      // console.log('calculBufferPageStats serieFinished', JSON.parse(JSON.stringify(serieFinished)), JSON.parse(JSON.stringify(filteredSesions.length)));
    }
    this.serieStats.push({
      title: 'Meilleur score',
      stat: bestScore,
      text: this.serie.type === 'Discovery' ? ' / 10' : ' / 40',
    });
    this.serieStats.push({
      title: 'Série réalisée',
      stat: serieFinished,
      text: ' fois',
    });
    this.serieStats.push({
      title: 'Dernier score',
      stat: this.lastScore,
      text: this.serie.type === 'Discovery' ? ' / 10' : ' / 40',
    });
  }

  showLastResults() {
    if (!!this.lastResultSession) {
      this.openLink(
        'series/' +
          this.serieType +
          '/' +
          this.lastResultSession.serieId +
          '/last-results/' +
          this.lastResultSession.id
      );
    } else {
      console.error('bufferPage lastResultLink: No lastSession found!');
      this.showModalSerieError();
    }
  }

  skipFxCount() {
    if (!!this.skipUrl) {
      this.urlSkipped = true;
      this.openLink(this.skipUrl);
    }
  }

  launchFxCount(link: string) {
    const btn = this.roundedBtnLaunch.nativeElement;
    const btnPosition = btn.getBoundingClientRect();
    this.skipUrl = link;
    this.renderer.setStyle(
      this.fxCircle.nativeElement,
      'margin-top',
      `${btnPosition.top}px`
    );
    this.fxCountShown = true;
    this.renderer.setStyle(this.fxCircle.nativeElement, 'opacity', '1');
    this.renderer.setStyle(
      this.fxCircle.nativeElement,
      'transition',
      'all .4s ease-in-out'
    );
    setTimeout(() => {
      const scale = Math.floor(Math.ceil(window.innerHeight / 66) * 1.8);
      this.renderer.setStyle(
        this.fxCircle.nativeElement,
        'transform',
        `scale(${scale})`
      );
      setTimeout(() => {
        this.renderer.setStyle(this.three.nativeElement, 'display', 'flex');
        setTimeout(() => {
          this.renderer.setStyle(
            this.three.nativeElement,
            'transform',
            'scale(2)'
          );
          this.renderer.setStyle(this.three.nativeElement, 'opacity', '0');
          setTimeout(() => {
            this.renderer.setStyle(this.two.nativeElement, 'display', 'flex');
            setTimeout(() => {
              this.renderer.setStyle(
                this.two.nativeElement,
                'transform',
                'scale(2)'
              );
              this.renderer.setStyle(this.two.nativeElement, 'opacity', '0');
              setTimeout(() => {
                this.renderer.setStyle(
                  this.one.nativeElement,
                  'display',
                  'flex'
                );
                setTimeout(() => {
                  this.renderer.setStyle(
                    this.one.nativeElement,
                    'transform',
                    'scale(2)'
                  );
                  this.renderer.setStyle(
                    this.one.nativeElement,
                    'opacity',
                    '0'
                  );
                  setTimeout(() => {
                    this.renderer.setStyle(
                      this.go.nativeElement,
                      'display',
                      'flex'
                    );
                    setTimeout(() => {
                      this.renderer.setStyle(
                        this.go.nativeElement,
                        'transform',
                        'scale(2)'
                      );
                      this.renderer.setStyle(
                        this.go.nativeElement,
                        'opacity',
                        '0'
                      );
                      setTimeout(() => {
                        if (!this.urlSkipped) {
                          this.openLink(link);
                        }
                      }, 700);
                    }, 20);
                  }, 700);
                }, 20);
              }, 700);
            }, 20);
          }, 700);
        }, 20);
      }, 400);
    }, 0);
  }

  launchSerie() {
    if (this.serieType === 'erreurs') {
      if (!this.serieErrorAvailable) {
        console.error('Serie Mes Erreurs - No errors available');
      } else {
        // console.log('serie error -> ', this.serie);
        // console.log('session error => ', this.sessionError);
        if (!this.isDesktop) {
          this.launchFxCount(
            'series/' +
              this.serieType +
              '/' +
              this.serie.id +
              '/0/' +
              this.sessionError.id
          );
        } else {
          this.openLink(
            'series/' +
              this.serieType +
              '/' +
              this.serie.id +
              '/0/' +
              this.sessionError.id
          );
        }
      }
    } else {
      if (this.userLifeCycle.isUserGuest && this.questionIndex >= 3) {
        this.openModalPack(null, 'modalSeriesGuest');
      } else {
        if (!this.waitingForApi) {
          const modes = {
            entrainements: 'Training',
            examens: 'Exam',
            thematiques: 'Training',
          };
          this.waitingForApi = true;
          this.sessionsService
            .openSessionBySerie(this.serie, this.student, {
              mode: modes[this.serieType],
            })
            .subscribe(
              session => {
                this.waitingForApi = false;
                if (!!session) {
                  const questionIndex =
                    !!session && !!session.answersCount
                      ? session.answersCount
                      : 0;
                  if (
                    this.serie.scope === 'free' &&
                    this.userLifeCycle.isUserGuest &&
                    questionIndex >= 3
                  ) {
                    this.openModalPack(null, 'modalSeriesGuest');
                  } else {
                    if (!this.isDesktop && questionIndex === 0) {
                      this.launchFxCount(
                        'series/' +
                          this.serieType +
                          '/' +
                          this.serieId +
                          '/' +
                          this.questionIndex +
                          '/' +
                          session.id
                      );
                    } else {
                      this.openLink(
                        'series/' +
                          this.serieType +
                          '/' +
                          this.serieId +
                          '/' +
                          this.questionIndex +
                          '/' +
                          session.id
                      );
                    }
                  }
                } else {
                  // session null
                  this.showModalSerieError();
                }
              },
              err => {
                this.waitingForApi = false;
                console.error(`openSessionBySerie: ${JSON.stringify(err)}`);
                this.showModalSerieError();
              }
            );
        }
      }
    }
  }

  goBack() {
    if (this.bufferLocked || this.serieType === 'erreurs') {
      this.openLink('code');
    } else {
      this.openLink('series/' + this.serieType);
    }
  }

  unlock() {
    if (this.userLifeCycle.isUserGuest) {
      if (this.serieType === 'examens') {
        this.openModalPack(null, 'marketingRegister');
      } else if (this.serieType === 'thematiques') {
        this.openModalPack(null, 'marketingRegister');
        // this.openModalPack({
        //   item_id: 'big_pack',
        //   item_promo_type: 'regular',
        //   item_location_id: 'marketingregular',
        //   item_location_format: 'modale',
        //   item_promo_content: 'reserved',
        // }, 'marketingRegular');
      } else if (this.serieType === 'erreurs') {
        this.openModalPack(null, 'marketingRegister');
        // this.openModalPack({
        //   item_id: 'big_pack',
        //   item_promo_type: 'regular',
        //   item_location_id: 'marketingregular',
        //   item_location_format: 'modale',
        //   item_promo_content: 'reserved',
        // }, 'marketingRegular');
      }
    } else if (this.userLifeCycle.isUserRegistered) {
      // theoriquement plus possible avec Adieu Code Simone
      if (this.serieType === 'thematiques') {
        this.openModalPack(
          {
            item_id: 'big_pack',
            item_promo_type: 'regular',
            item_location_id: 'marketingregular',
            item_location_format: 'modale',
            item_promo_content: 'reserved',
          },
          'marketingRegular'
        );
      } else if (this.serieType === 'erreurs') {
        this.openModalPack(
          {
            item_id: 'big_pack',
            item_promo_type: 'regular',
            item_location_id: 'marketingregular',
            item_location_format: 'modale',
            item_promo_content: 'reserved',
          },
          'marketingRegular'
        );
      }
    }
  }

  async resetErrors() {
    this.seriesService.resetErrors().subscribe(
      async res => {
        if (!!res) {
          const resSeriesList =
            await this.seriesService.seriesContext.getSeriesList(this.student);
          if (
            !!resSeriesList &&
            !!resSeriesList.errorCode &&
            resSeriesList.errorCode === 'E301'
          ) {
            this.seriesList = [];
            this.seriesListFailed = true;
          } else {
            this.seriesList = resSeriesList;
          }
          const serieError = this.seriesList.find(elt => elt.type === 'Error');
          if (!!serieError) {
            let serie = null;
            const resGetSerie = await this.seriesService.seriesContext.getSerie(
              serieError.id,
              this.student,
              false,
              true
            );
            if (
              !!resGetSerie &&
              !!resGetSerie.errorCode &&
              resGetSerie.errorCode === 'E301'
            ) {
              this.getSerieFailed = true;
              this.userErrorHandlerService.addError({
                criticity: 20,
                service: 'getSerie',
                platform: 'both',
                data: resGetSerie.errorOriginal,
                errorCode: 'ssfsr',
              });
            } else {
              serie = resGetSerie;
            }
            if (!!serie) {
              serie.nbQuestions = 0;
              serie.questions = [];
              serieError.nbQuestions = 0;
              this.seriesService.errorSerie = serie;
              await this.seriesService.seriesContext.setSerie(
                serie,
                this.student
              );
              await this.seriesService.seriesContext.setSeriesList(
                this.seriesList,
                this.student
              );
              // console.log('serie', JSON.stringify(serie));
              // console.log('seriesList', JSON.stringify(this.seriesList));
              this.hideModalResetErrors();
              this.toasterService.create({
                text: 'Tes erreurs ont été remises à zéro 🥳',
                bgcolor: 'var(--color-success)',
                duration: '3000',
              });
              this.openLink('code');
            } else {
              this.hideModalResetErrors();
              this.sentryService.sendToSentry(
                'BufferPage -> resetError() -> SerieError not found!',
                this.studentService.student
              );
              this.easyDebugLogger.logManual(
                'BufferPage -> resetError() -> SerieError not found!'
              );
            }
          } else {
            this.hideModalResetErrors();
            this.sentryService.sendToSentry(
              'BufferPage -> resetError() -> SerieError not found!',
              this.studentService.student
            );
            this.easyDebugLogger.logManual(
              'BufferPage -> resetError() -> SerieError not found!'
            );
          }
        }
      },
      err => {
        this.hideModalResetErrors();
        if (this.networkStatusService?.isOffline()) {
          this.navigationService.saveLinkToReload();
        } else {
          this.toasterService.create({
            text: 'Une erreur est survenue !',
            bgcolor: 'var(--color-warning)',
            duration: '3000',
          });
        }
      }
    );
  }

  hideModalResetErrors() {
    this.displayModalResetErrors = false;
  }

  showModalResetErrors() {
    this.displayModalResetErrors = true;
  }

  hideModalSerieError() {
    this.displayModalSerieError = false;
  }

  showModalSerieError() {
    this.displayModalSerieError = true;
  }

  callHideModalNoErrors(action?) {
    this.modalSerieError.closeModal();
  }

  async openModalPack(
    bannerInfo?: any,
    type?: string,
    noClose = false,
    customClass = ''
  ) {
    // evs-global.scss : small-modal | medium-modal
    if (!type) {
      type = 'marketingRegular';
    }
    let props;
    if (!!bannerInfo) {
      props = {
        type: type,
        bannerInfo: bannerInfo,
      };
    } else {
      props = {
        type: type,
        bannerInfo: null,
      };
    }
    let modal;
    if (noClose) {
      modal = await this.modalController.create({
        component: ModalMarketingComponent,
        backdropDismiss: false,
        cssClass: customClass,
        componentProps: props,
      });
    } else {
      modal = await this.modalController.create({
        component: ModalMarketingComponent,
        cssClass: customClass,
        componentProps: props,
      });
    }
    return await modal.present();
  }

  async openModalIframe(url: any, type?: string, noClose = true) {
    if (!type) {
      type = 'iframe';
    }
    let modal;
    if (noClose) {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        backdropDismiss: false,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          type: type,
          url: url,
        },
      });
    } else {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          type: type,
          url: url,
        },
      });
    }
    return await modal.present();
  }

  closeModals() {
    const modals = document.getElementsByTagName('ion-modal');
    while (modals.length > 0) {
      modals[0].parentNode.removeChild(modals[0]);
    }
  }

  async openLink(link, options = {}) {
    const callbackUrl = await this.navigationService.open(link, options);
    if (!!callbackUrl && callbackUrl !== '') {
      this.openModalIframe(callbackUrl);
    }
  }
}
